import { ColorPicker } from "@/shared/components/ColorPicker";
import { Field } from "react-final-form";

interface ColorPickerProps {
  name: string;
  helperText?: string;
  variant?: "outlined" | "filled" | "standard";
  fullWidth?: boolean;
  [key: string]: any;
}

export function ColorPickerField(props: ColorPickerProps) {
  return (
    <Field
      {...props}
      render={({
        input: { name, onChange, value, ...restInput },
        meta,
        helperText,
        ...rest
      }: any) => (
        <ColorPicker
          {...rest}
          name={name}
          helperText={(meta.touched && meta.error) || helperText}
          error={meta.error && meta.touched}
          inputProps={restInput}
          onChange={onChange}
          value={value}
          variant="outlined"
          fullWidth={props.fullWidth}
        />
      )}
    />
  );
}
